export default __webpack_public_path__ + "assets/cart-icon-black.2ae73187.webp";